
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
}

.filter-container[open]{
    background-color:var(--color-neutral-white);
    border-radius:var(--border-radius-rounded-default);
    outline:1px solid var(--color-neutral-lighter);
    position:fixed;
    top:var(--spacing-02);
    left:0;
    height:calc(100vh - var(--spacing-02));
    right:0;
    padding:var(--spacing-02);
    z-index:var(--z-index-modal);
  }

.filter-container[open]::before{
      content:'';
      display:block;
      position:fixed;
      top:0;
      right:0;
      bottom:0;
      left:0;
      background-color:var(--color-neutral-dark);
      opacity:0.7;
      z-index:-1;
    }

.filter-container[open]::after{
      content:'';
      display:block;
      border-radius:var(--border-radius-rounded-default);
      position:absolute;
      top:0;
      right:0;
      bottom:0;
      left:0;
      background-color:var(--color-neutral-white);
      z-index:-1;
    }

.filter-container[open] .filter-container-label{
      border-bottom-color:transparent;
    }

.filter-container[open] .filter-content{
      overflow-y:scroll;
      height:100%;
      padding:var(--spacing-02);
    }

summary{
  list-style:none;
}

summary::marker,
  summary::-webkit-details-marker{
    display:none;
  }

.filter-container-label{
  font-size:var(--body-helper-font-size);
  display:flex;
  align-items:center;
  justify-content:flex-end;
  gap:var(--spacing-02);
  padding:var(--spacing-02);
  border-bottom:1px solid var(--color-neutral-lighter);
}

.filter-container-label sic-icon{
    color:var(--color-primary-default);
  }
`;